import { useEffect } from "react";
import { useTranslationApp } from "../../lib/i18next";
import { normalizeAppLanguage } from "../../utils/i18nLanguage";
import { getAiCompetitorsThanksUrl } from "./aiCompetitorsConstants";

const AiCompetitorsThanks = () => {
  const { i18n } = useTranslationApp();
  const currentLanguage = normalizeAppLanguage(i18n.language) || "en";

  useEffect(() => {
    window.location.replace(getAiCompetitorsThanksUrl(currentLanguage));
  }, [currentLanguage]);

  return null;
};

export default AiCompetitorsThanks;
